import { useEffect } from "react";

const SITE = "AimanRe.my";
const BASE_URL = "https://aimanre.my";
const DEFAULT_DESCRIPTION =
  "A personal notebook about things I'm learning, small hobbies, and the quiet parts of everyday life.";

export function usePageMeta({ title, description = DEFAULT_DESCRIPTION, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — A personal notebook`;
    const url = `${BASE_URL}${path}`;

    document.title = fullTitle;

    const setContent = (selector, content) => {
      const element = document.querySelector(selector);
      if (element) element.setAttribute("content", content);
    };

    setContent('meta[name="description"]', description);
    setContent('meta[property="og:title"]', fullTitle);
    setContent('meta[property="og:description"]', description);
    setContent('meta[property="og:url"]', url);
    setContent('meta[name="twitter:title"]', fullTitle);
    setContent('meta[name="twitter:description"]', description);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
  }, [title, description, path]);
}
